import {React, _, observer, classNames, Fragment} from '@api'
import { MenuDivider } from '@blueprintjs/core'
import {CardSizeSlider, GroupByGroupContextMenu, GroupByGroupStoreContext, GroupSwatchContextMenuExtra, NoImagePlaceholder, SpecContextMenuItem, useGroupBySwatchesStore, useGrouping} from '@modules'
import { defaultGroupBySettings, LibraryItemConfig, useCatalog} from '@stores'

export const GroupSwatchesContextMenu = observer(function GroupSwatchesContextMenu() {
  const {groupStore, groupStore: {grouping: {settings}}, swatchFields, contextMenu: {extra}} = useGroupBySwatchesStore()

  return <GroupByGroupStoreContext.Provider value={groupStore}>
    {/*<GroupSwatchesSizeSlider />*/}
    {/*<MenuDivider />*/}
    <GroupSwatchContextMenuItem />
    <GroupByGroupContextMenu />
  </GroupByGroupStoreContext.Provider>
});

export const GroupSwatchContextMenuItem = observer(function GroupSwatchContextMenuItem() {
  const {stores: {contextMenu: {extra}}} = useCatalog()

  if (!extra) return null

  const {item, field, esIndex} = extra as GroupSwatchContextMenuExtra

  if (esIndex) {
    console.log({item, field, esIndex})
    return <SpecContextMenuItem dividerAfter data={item} index={esIndex} field={field}/>
  }

  return null
})

export const GroupSwatchesSizeSlider = observer<{dividerBefore?: boolean, dividerAfter?: boolean}>(function GroupSwatchesSizeSlider({dividerBefore, dividerAfter}) {
  const {settings} = useGrouping()
  if (_.isEmpty(settings.swatches)) return null
  return <Fragment>
    {dividerBefore && <MenuDivider/>}
    <CardSizeSlider min={10} max={64} defaultValue={32} value={settings.swatchSize ?? defaultGroupBySettings.settingsForLevel[0].swatchSize} onChange={(e, v: number) => settings.swatchSize = v} tooltipTitle='Swatch Size'/>
    {dividerAfter && <MenuDivider/>}
  </Fragment>
})


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/GroupByCatalog_Groups/GroupByCatalog_LoadMore/GroupSwatchesContextMenu.tsx